import script from "./MessageDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageDetails.vue?vue&type=script&lang=ts&setup=true"

import "./MessageDetails.vue?vue&type=style&index=0&id=81105266&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81105266"]])

export default __exports__